import { render, staticRenderFns } from "./specialzone.vue?vue&type=template&id=5aa653a0&scoped=true"
import script from "./specialzone.vue?vue&type=script&lang=ts"
export * from "./specialzone.vue?vue&type=script&lang=ts"
import style0 from "./specialzone.vue?vue&type=style&index=0&id=5aa653a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa653a0",
  null
  
)

export default component.exports